import { Box, Typography, styled } from '@mui/material';
import { ProductAddonCard } from './ProductAddonCard';
import { ProductAddonSearch } from 'models/ProductSearch';
import { useTranslation } from 'react-i18next';

const CollectionItem = styled(Box)(() => ({
    padding: '5px',
    alignItems: 'stretch',
}));

const ProductSubstitutes: React.FC<ProductSubstituesProps> = (props) => {
    const { t } = useTranslation('product', {
        keyPrefix: 'PRODUCT.TABS.ADDONS',
    });

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
            }}
        >
            <Typography variant="h3" gutterBottom>
                {t('SUBSTITUTES')}
            </Typography>
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    gap: '4px',
                    width: props.substitutes.length > 3 ? '100%' : '65%',
                }}
            >
                {props.substitutes.map((item, key) => {
                    return (
                        <CollectionItem key={item.id} sx={{ width: '33%' }}>
                            <ProductAddonCard
                                key={key}
                                product={item}
                                handle={''}
                            />
                        </CollectionItem>
                    );
                })}
            </Box>
        </Box>
    );
};

export default ProductSubstitutes;

type ProductSubstituesProps = {
    substitutes: ProductAddonSearch[];
};
